(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.side-nav.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.side-nav.js');
"use strict";

const {
  ReactPaper: Paper
} = svs.ui;
const {
  SkeletonLine
} = svs.components.lbUi;
const WagerSkeletonSideNav = () => React.createElement(Paper, {
  branding: "sport",
  className: "pg_my_bets_wager_fallback__grid__side_nav"
}, React.createElement("div", {
  className: "coupon-match-info-skeleton"
}, React.createElement(SkeletonLine, {
  className: "coupon-match-info-title-skeleton"
}), React.createElement(SkeletonLine, {
  className: "coupon-match-info-data-skeleton"
}), React.createElement(SkeletonLine, {
  className: "coupon-match-info-data-skeleton"
}), React.createElement(SkeletonLine, {
  className: "coupon-match-info-data-skeleton"
})), React.createElement("div", {
  className: "coupon-match-info-skeleton"
}, React.createElement(SkeletonLine, {
  className: "coupon-match-info-title-skeleton"
}), React.createElement(SkeletonLine, {
  className: "coupon-match-info-data-skeleton"
})));
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonSideNav', WagerSkeletonSideNav);

 })(window);